import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiPost } from '../query';
import { useBuildVars } from '../config';

export function useForgotPassword() {
  const queryClient = useQueryClient();
  const apipost = useApiPost({ isLogoutApi: true });
  const { appId } = useBuildVars();
  const url =
    appId === 'x4ec'
      ? '/account-management/endcustomer/v1/users/forgot-password'
      : '/account-management/v1/users/forgot-password';
  return useMutation({
    mutationFn: async (body: { EmailAddress: string; UserName: string }) => {
      const { EmailAddress, UserName } = body;
      const updateData = {
        emailAddress: EmailAddress,
        userName: UserName,
      };
      const data = await apipost(url, updateData);
      return data;
    },
    onError: () => {
      return;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [url],
      });
    },
  });
}
